import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SubmissionModal from "./components/SubmissionModal";
import Home from "./pages/Home";
import ProjectsPage from "./pages/ProjectsPage";
import AdminPage from "./pages/AdminPage";
import AuthPage from "./pages/AuthPage";
import ResetPage from "./pages/ResetPage";
import MyProjectsPage from "./pages/MyProjectsPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const [submitOpen, setSubmitOpen] = useState(false);
  const { dark } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  const openSubmit = () => {
    if (user) setSubmitOpen(true);
    else navigate("/auth?next=submit");
  };

  return (
    <div className={`min-h-screen ${dark ? "bg-[#0B1120] text-slate-100" : "bg-[#F8FAFC] text-slate-900"}`}>
      <ScrollToTop />
      <Header onSubmit={openSubmit} />
      <Routes>
        <Route path="/" element={<Home onOpenSubmit={openSubmit} />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/reset-password" element={<ResetPage />} />
        <Route path="/my-projects" element={<MyProjectsPage />} />
      </Routes>
      <Footer />
      <SubmissionModal open={submitOpen} onClose={() => setSubmitOpen(false)} />
      <Toaster theme={dark ? "dark" : "light"} position="top-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <Shell />
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
